import AppState from '../../interfaces/app-state';

export const selectTailors = (state: AppState) => state.tailor.tailors;
export const selectTailorPlaceDetails = (state: AppState) => state.tailor.tailorPlaceDetails;
